import { SortOrder, Worklog, WorklogWhereInput } from '../../../generated/graphql'

type ActiveWorklog = Pick<
  Worklog,
  | 'id'
  | 'end_time'
  | 'deleted_at'
  | 'general_activity'
  | 'specific_activity'
  | 'activity_objective'
  | 'start_time'
  | 'status'
  | 'row_version'
>

interface ResolveActiveWorklogParams {
  userId?: string
  fetchWorklogs: (where: WorklogWhereInput) => Promise<ActiveWorklog[]>
}

export interface WorklogStates {
  activeWorklog: ActiveWorklog | undefined
  pendingObservationWorklog: ActiveWorklog | undefined
}

export const ACTIVE_WORKLOG_ORDER_BY = [{ created_at: SortOrder.Desc }]

export function isPendingWorklog(worklog: ActiveWorklog | null | undefined): worklog is ActiveWorklog {
  return Boolean(worklog && worklog.deleted_at == null && worklog.end_time == null)
}

export async function resolveWorklogStates({
  userId,
  fetchWorklogs,
}: ResolveActiveWorklogParams): Promise<WorklogStates> {
  if (!userId) return { activeWorklog: undefined, pendingObservationWorklog: undefined }

  const rows = await fetchWorklogs({
    user_id: { equals: userId },
    deleted_at: { equals: null },
    OR: [
      { end_time: { equals: null } },
      { status: { equals: 'OBSERVATION_PENDING' } },
    ],
  })

  return {
    activeWorklog: rows.find(isPendingWorklog),
    pendingObservationWorklog: rows.find(
      r => r.status === 'OBSERVATION_PENDING' && r.end_time != null
    ),
  }
}

export async function resolveActiveWorklog(params: ResolveActiveWorklogParams): Promise<ActiveWorklog | undefined> {
  return (await resolveWorklogStates(params)).activeWorklog
}
